import fetch from '../utils/fetch';
import {ApiURL} from './config';

class RoleApi {

    static getAll() {
        return fetch(`${ApiURL}/role`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }
}

export default RoleApi;


/** WEBPACK FOOTER **
 ** ./src/api/roleApi.js
 **/